/** @jsxImportSource @emotion/react */
import React, { useEffect, useRef } from 'react';

type ClickAwayListenerProps = {
  children: React.ReactElement;
  onClickAway: () => void;
  isActive?: boolean;
};

export const ClickAwayListener = ({
  children,
  onClickAway,
  isActive = true,
}: ClickAwayListenerProps): JSX.Element => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!isActive) return;

    const handleClickOutside = (event: MouseEvent) => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        onClickAway();
      }
    };

    // タイミングを少し遅らせて、クリックイベントが先に処理されるようにする
    const timeoutId = setTimeout(() => {
      document.addEventListener('mousedown', handleClickOutside);
    }, 0);

    return () => {
      clearTimeout(timeoutId);
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [onClickAway, isActive]);

  return React.cloneElement(children, { ref });
};
